import { MessageCircle } from "lucide-react";

export default function FloatingWhatsApp({ number = "919999999999", message = "Hi PPrints, I'd like a quote." }) {
  const url = `https://wa.me/${number}?text=${encodeURIComponent(message)}`;
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp"
      className="fixed bottom-6 right-6 z-40 inline-flex items-center gap-2 rounded-full bg-brand-green hover:bg-brand-green-dark text-white pl-4 pr-5 py-3 shadow-2xl transition-all hover:-translate-y-0.5"
    >
      <span className="relative grid place-items-center">
        <span className="absolute inset-0 rounded-full bg-brand-green animate-ping opacity-50" />
        <MessageCircle className="h-5 w-5 relative" />
      </span>
      <span className="font-semibold text-sm">Chat on WhatsApp</span>
    </a>
  );
}
